import {createApi} from "@reduxjs/toolkit/dist/query/react"
import {apiQuery} from "../../utils/api-config";
import {Response} from "../../types/response/Response";
import {EmployeeDTO} from "../../types/auth/EmployeeDTO";

export const configurationApi = createApi({
    reducerPath: "permission",
    baseQuery: apiQuery,
    tagTypes: ["employee", "weekdays"],
    endpoints: builder => ({
        getSelfEmployee: builder.query<Response<EmployeeDTO>, void>({
            query: () => '/configuration/get-self-employee',
            providesTags: ['employee']
        }),

        getWeekDays: builder.query<Response<any>, void>({
            query: () => '/configuration/weekdays',
            providesTags: ["weekdays"]
        })
    })
})

export const {useGetSelfEmployeeQuery, useGetWeekDaysQuery} = configurationApi
